import React, { PureComponent } from 'react'
import { navigateTo } from 'gatsby-link'
import styles from './styles.module.scss'

export default class ContactForm extends PureComponent {
  state = {
    name: '',
    phone: '',
    email: '',
    comments: '',
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...this.state }),
    })
      .then(() => navigateTo(form.getAttribute('action')))
      .catch(error => console.log(error))
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const {
      name,
      phone,
      email,
      comments,
    } = this.state

    return (
      <div>
        <form
          name='contact'
          method='post'
          action='/thank-you/'
          data-netlify='true'
          data-netlify-honeypot='bot-field'
          onSubmit={this.handleSubmit}
        >
          <input type='hidden' name='form-name' value='contact' />
          <fieldset className={styles.fieldSet}>
            <p>
              <label className={styles.label}>
                <input placeholder='Name' type='text' name='name' value={name} onChange={this.handleChange} required />
              </label>
            </p>
            <p>
              <label className={styles.label}>
                <input placeholder='Phone: xxx-xxx-xxxx' type='text' name='phone' value={phone} title='xxx-xxx-xxxx' onChange={this.handleChange} pattern='[0-9]{3}-[0-9]{3}-[0-9]{4}' />
              </label>
            </p>
            <p>
              <label className={styles.label}>
                <input placeholder='Email' required type='email' name='email' value={email} onChange={this.handleChange} />
              </label>
            </p>
            <p>
              <label className={styles.label}>
                <textarea className={styles.textArea} placeholder='Questions/Comments' required name='comments' value={comments} onChange={this.handleChange} />
              </label>
            </p>
            <p>
              <button type='submit'>Submit</button>
            </p>
          </fieldset>
        </form>
      </div>
    )
  }
}

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js